<div class="modal-header">
  {{ task?.description }}
  <button type="button" class="text-white close" data-dismiss="modal" aria-hidden="true" (click)="clear()">
    <fa-icon icon="times"></fa-icon>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="border border-secondary col m-2 p-3 rounded">
      <label class="form-control-label" jhiTranslate="app.geracaozTask.volunteerNeeded">Volunteer Needed</label>
      <p class="form-control-plaintext">{{ task?.volunteerNeeded }}</p>
    </div>
    <div class="border border-secondary col m-2 p-3 rounded">
      <label class="form-control-label" jhiTranslate="app.geracaozTask.objective">Formation Area Id</label>
      <p class="form-control-plaintext">{{ task?.objective?.objective }}</p>
    </div>
  </div>
  <div class="row">
    <div class="border border-secondary col m-2 p-3 rounded">
      <table *ngIf="hasDays()" class="table align-items-center table-flush mb-0 table-responsive">
        <thead class="thead-light">
          <tr>
            <th scope="col" class="text-center" style="min-width: 110px">Datas</th>
            <th scope="col" class="text-center border-left">Manhã</th>
            <th scope="col" class="text-center border-left">Tarde</th>
            <th scope="col" class="text-center border-left" rowspan="2" style="line-height: 25px; vertical-align: middle">Feriados</th>
            <th scope="col" class="text-center border-left" rowspan="2" style="line-height: 50px; vertical-align: middle">
              Dias da semana com ocorrência da tarefa
            </th>
            <th scope="col" class="text-center border-left" rowspan="2" style="line-height: 25px; vertical-align: middle">
              <span [pTooltip]="'Total de dias calendarizados para esta tarefa'" class="label label-primary"
                >Total de {{ getTotalDays(task?.schedule) }} dias
              </span>
              <br />
              <span [pTooltip]="'Total de horas calendarizadas para esta tarefa'" class="label label-primary"
                >Total de {{ getTotalHours(task?.schedule) }} horas
              </span>
              <br />
            </th>
          </tr>
          <tr>
            <th scope="col" class="text-center border-left">
              De
              <br />
              Até
            </th>
            <th scope="col" class="text-center border-left">
              Das
              <br />
              Até
            </th>
            <th scope="col" class="text-center border-left">
              Das
              <br />
              Até
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let day of getDays() | orderBy: 'dateStart'">
            <td class="text-center">
              {{ day.dateStart | formatMediumDate }}
              <br />
              {{ day.dateEnd | formatMediumDate }}
            </td>
            <td class="text-center border-left">
              {{ day.morningFrom | formatTime }}
              <br />
              {{ day.morningTo | formatTime }}
            </td>
            <td class="text-center border-left">
              {{ day.afternoonFrom | formatTime }}
              <br />
              {{ day.afternoonTo | formatTime }}
            </td>
            <td class="text-center border-left">{{ day.holidays }}</td>
            <td class="text-center border-left">
              <span *ngFor="let dow of days" [ngClass]="{ 'badge-success': day.dow.includes(dow.id) }" class="badge mr-2">{{
                dow.name
              }}</span>
            </td>
            <td class="text-center border-left">
              <span class="label label-NEW">{{ getHoursPerDay(day) | number: '1.0-2' }} hora(s) / dia</span>
              <br />
              <span class="label label-NEW">Total de {{ getTotalDaysPerPeriod(day) | number: '1.0-2' }} dias</span>
              <br />
              <span class="label label-NEW">Total de {{ getTotalHoursPerPeriod(day) | number: '1.0-2' }} horas</span>
              <br />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
